<template>
    <Modal ref="Modal" :title="$t('labels.order_status')">
        <div class="modal-body">
            <FormGroup :label="$t('labels.name')" :required="true">
                <Input
                    v-model="name"
                />
            </FormGroup>
            <FormGroup :label="$t('labels.color')" :required="true">
                <Input 
                    v-model="color"
                    type="color"
                />
            </FormGroup>
        </div>
        <div class="card-footer d-flex justify-content-end">
            <Button color="indigo" @click="create">
                <span>{{ $t('buttons.create') }}</span>
            </Button>
        </div>
    </Modal>
</template>
<script>
import Modal from "../../../../../components/new/modal/AppModal.vue";
import FormGroup from "../../../../../components/new/form/group/FormGroup.vue";
import Input from "../../../../../components/new/form/Input.vue";
import Button from "../../../../../components/new/button/AppButton.vue";

import { httpClient } from "../../../../../services/HttpClient";
import MessageNotificator from "../../../../../services/MessageNotificator";

export default {
    name: "CreateOrderStatusModal",
    components: {
        Modal, FormGroup, Input, Button
    },
    emits: ['status:created'],
    data() {
        return {
            name: null,
            color: null
        }
    },
    methods: {
        show() {
            this.$refs.Modal.show()
        },
        create() {
            httpClient.post(`/projects/${this.$route.params.projectUuid}/crm/statuses`, {
                name: this.name,
                color: this.color
            }).then((response) => {
                this.$emit('status:created', response.data.data)
                this.$refs.Modal.hide()
                new MessageNotificator().success(this.$t("alerts.success"))
            })
        }
    }
}
</script>